type Props = {
  isOpen: boolean;
  onClick: () => void;
};

const HamburgerButton: React.FC<Props> = ({ isOpen, onClick }) => {
  const lineColor = isOpen ? "bg-secondary" : "bg-logoBlue"; 
  // sau bg-secondary dacă ai definit-o în Tailwind

  return (
    <button
      onClick={onClick}
      className="relative w-8 h-6 flex flex-col justify-between items-center z-1000"
      aria-label="Toggle menu"
    >
      <span
        className={`h-[4.5px] w-full ${lineColor} rounded transition-all duration-300 ${
          isOpen ? "rotate-45 translate-y-2" : ""
        }`}
      />
      <span
        className={`h-[3.5px] w-full ${lineColor} rounded transition-all duration-300 ${
          isOpen ? "opacity-0" : ""
        }`}
      />
      <span
        className={`h-[1.5px] w-full ${lineColor} rounded transition-all duration-300 ${
          isOpen ? "-rotate-45 -translate-y-2" : ""
        }`}
      />
    </button>
  );
};

export default HamburgerButton;
